<template>
  <div class="myhome-empty">
    <div class="myhome-empty__welcome-section dea-bg-grey-light">
      <div class="grid grid--wide">
        <div class="myhome-empty__welcome-container xs-12">
          <div class="myhome-empty__welcome-message">
            <h2 class="myhome-empty__welcome-message--title dea-heading--regular-xxl">Ti diamo il benvenuto!</h2>
            <p class="dea-heading--light-xl">Qui troverai tutto ciò che può esserti <br />utile nel mondo Deascuola!</p>
            <p class="dea-heading--light-xl">Scopri come funziona la <br />tua Area Personale:</p>
          </div>
          <div class="myhome-empty__video">
            <iframe id="ytplayer" class="myhome-empty__video-player" :src="videoUrl" frameborder="0" allowfullscreen />
          </div>
        </div>
      </div>
    </div>
    <div class="grid grid--wide">
      <h3 class="xs-12 dea-heading--light-xl myhome-empty__where-to-start">Non sai da dove partire?</h3>
      <div v-if="!student && !parent" class="xs-12 myhome-empty__start-section">
        <div v-if="!principal && !generic" class="myhome-empty__start-section-book">
          <h3 class="dea-heading--medium-xxl">I miei libri</h3>
          <EmptyBook
            align="vertical"
            :link-color="linkColor"
            :parent="parent"
            :student="student"
            :user="user"
            @open-activation-modal="$emit('open-activation-modal')"
            @open-evaluation-modal="$emit('open-evaluation-modal')"
          />
        </div>
        <div
          class="myhome-empty__start-section-event"
          :class="{ 'myhome-empty__start-section-event--wide': principal || generic }"
        >
          <h3 v-if="!principal && !generic" class="dea-heading--medium-xxl">I miei eventi formativi</h3>
          <EmptyEvent
            v-if="teacherOrOther"
            align="vertical"
            :link-color="linkColor"
            :principal="principal"
            :parent="parent"
            :student="student"
            @open-activation-modal="$emit('open-activation-modal')"
            @open-evaluation-modal="$emit('open-evaluation-modal')"
          />
        </div>
      </div>
      <div v-else class="xs-12 myhome-empty__start-section myhome-empty__start-section--student">
        <h3 class="dea-heading--medium-xxl">I miei libri</h3>
        <EmptyBook
          align="horizontal"
          :link-color="linkColor"
          :parent="parent"
          :student="student"
          :user="user"
          @open-activation-modal="$emit('open-activation-modal')"
          @open-evaluation-modal="$emit('open-evaluation-modal')"
        />
      </div>
      <div class="xs-12 myhome-empty__assistance">
        <hr class="small-line--grey" />
        <div class="xs-12 myhome-empty__agency" :class="{ 'myhome-empty__agency--student': student }">
          <p class="dea-heading--medium-l">
            <template v-if="student">
              Hai bisogno di aiuto? Consulta la nostra Area Assistenza
            </template>
            <template v-else-if="generic">
              Hai bisogno di assistenza?
            </template>
            <template v-else>
              Se hai bisogno di assistenza o vuoi contattare la tua agenzia di riferimento:
            </template>
          </p>
          <Buttons
            type="a"
            target="_blank"
            class="dea-button dea-button--large dea-button--iconRight"
            :href="agentsUrl"
            icon="richiedi-info"
          >
            <template v-if="generic">
              FAQ e Assistenza
            </template>
            <template v-else-if="teacherOrOther">
              Assistenza e agenzia
            </template>
            <template v-else>
              Assistenza
            </template>
          </Buttons>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Buttons from "@/components/elements/Buttons";
import EmptyBook from "~/components/books/components/EmptyBook";
import EmptyEvent from "~/components/books/components/EmptyEvent";
import UserLinks from "~/components/books/mixins/UserLinks";

export default {
  name: "EmptyHome",
  components: {
    Buttons,
    EmptyBook,
    EmptyEvent,
  },
  mixins: [UserLinks],
  props: {
    linkColor: {
      type: String,
      default: "",
    },
    generic: {
      type: Boolean,
      default: false,
    },
    principal: {
      type: Boolean,
      default: false,
    },
    parent: {
      type: Boolean,
      default: false,
    },
    student: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showActivationModal: false,
      showEvaluationModal: false,
    };
  },
  computed: {
    bookSectionClass() {
      return !this.teacherOrOther ? "xs-12" : "xs-12 s-6";
    },
    teacherOrOther() {
      return !this.parent && !this.student;
    },
    videoUrl() {
      if (this.user.teacher) return this.$root.config.videoLaunch.teacher;
      if (this.user.student) return this.$root.config.videoLaunch.student;
      if (this.user.parent) return this.$root.config.videoLaunch.parent;
      return "";
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-empty {
  margin-bottom: $space-large;
  padding-top: $space-large;

  &__buttons-container {
    margin-bottom: $space-large;

    .myhome-header__buttons--right {
      @include media(">m") {
        margin-left: $space-base;
      }
    }
  }

  &__container {
    @include media("<=s") {
      padding: 0;
    }
    padding: 0 $space-x-large + $space-base;
  }

  &__welcome-container {
    @include media("<=m") {
      flex-direction: column;
    }

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: $space-base;
    padding-top: $space-base;
  }

  &__video {
    @include media(">m") {
      height: 312px;
      margin-right: $space-x-large + $space-base;
      padding-top: 0;
      width: 560px;
    }

    overflow: hidden;
    padding-top: 56.25%; // See https://blog.theodo.com/2018/01/responsive-iframes-css-trick/
    position: relative;

    &-player {
      @include media(">m") {
        height: 312px;
        width: 560px;
      }

      border: 0;
      height: 100%;
      left: 0;
      max-width: 100%;
      position: absolute;
      top: 0;
      width: 100%;
    }
  }

  &__welcome-section {
    margin-bottom: $space-intermediate;

    p:first-of-type {
      margin-top: $space-x-large;
    }
  }

  &__welcome-message,
  &__where-to-start,
  &__start-section {
    @include media(">m") {
      margin-left: $space-x-large + $space-base;
    }

    &--title {
      margin-top: 0;
    }

    &--student {
      justify-content: flex-start !important; //sass-lint:disable-line no-important
    }
  }

  &__start-section {
    @include media(">m") {
      margin-right: $space-x-large + $space-base;
    }
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }

  &__start-section-book,
  &__start-section-event {
    @include media(">=s") {
      width: 45%;
    }

    display: flex;
    flex-direction: column;
    width: 100%;
  }

  &__start-section-event--wide {
    @include media(">=s") {
      width: 100%;
    }

    .myhome-empty-event__content {
      flex-direction: row;

      .myhome-empty-event__description {
        margin-left: $space-s-large;
      }
    }
  }

  .small-line--grey {
    width: 100%;
  }

  &__agency {
    @include media("<=xs") {
      text-align: center;
    }
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: $space-intermediate 0 $space-x-large;

    &--student {
      margin: $space-base 0 $space-large;
    }
  }
}
</style>
